<template>
    <div>
        <div
            v-if="open"
            class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
            <div class="relative w-4/5 my-6 mx-auto max-w-6xl">
                <!--content-->
                <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-black-600 outline-none focus:outline-none">
                    <!--header-->
                    <div class="flex items-start justify-between p-4 rounded-t">
                        <h3 class="text-xl font-semibold">
                            {{ image.title }}
                        </h3>
                        <button
                            class="p-1 ml-auto bg-transparent border-0 text-white float-right text-2xl leading-none font-semibold outline-none focus:outline-none"
                            @click="$emit('close')">
                            <span class="bg-transparent text-white h-6 w-6 text-2xl block outline-none focus:outline-none">
                                &times;
                            </span>
                        </button>
                    </div>
                    <!--body-->
                    <div class="relative flex-auto flex justify-center">
                        <div
                            ref="slider"
                            class="beer-slider"
                            data-beer-label="AFTER">
                            <img
                                :src="image.after.full"
                                alt="After"
                                class="max-h-75">
                            <div
                                class="beer-reveal"
                                data-beer-label="BEFORE">
                                <img
                                    :src="image.before.full"
                                    alt="Before"
                                    class="max-h-75">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="open"
            class="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </div>
</template>

<script>
export default {
  props: {
    image: {
      type: Object,
    },
  },
  computed: {
    open() {
      return !!this.image;
    },
  },
  mounted() {
    if (!this.image) {
      return;
    }

    new window.BeerSlider(this.$refs.slider);
  },
};
</script>

<style>
    .beer-handle, .beer-range:focus~.beer-handle {
        background-color: rgba(167, 137, 85, 0.95);
    }
    .beer-handle::before, .beer-handle::after {
        color: white;
    }
    .beer-reveal {
        border-right: 2px solid rgba(167, 137, 85, 0.95);
    }
    .beer-slider::after, .beer-reveal::after {
        color: black;
    }
</style>
